module.exports = __webpack_public_path__ + "static/media/option4-4row.e644f72a.png";